import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import CAGR from "./components/Cagr";
import RevenueCollectionFunnel from "./components/RevenueCollectionFunnel";
import GeographicDistribution from "./components/GeographicDistribution";
import SectorDistribution from "./components/SectorDistribution";
import PartnerPerformance from "./components/PartnerPerformance";
import SectorPerformance from "./components/SectorPerformance";
import TopRevenueClients from "./components/TopRevenueClients";
import TopClientsDetails from "./components/TopClientsDetails";
import RevenueChangeLog from "./components/RevenueChangeLog";
import { currency_converter_inr, currency_converter_selected } from "../../utils/currencyUtils";
import TopRolesRisk from "./components/TopRolesRisk";
import TopClientRisk from "./components/TopClientRisk";
import QuarterRevenueTrend from "../../components/Modals/Dashboard/QuarterRevenueTrend";
import QuarterNetAddTrend from "../../components/Modals/Dashboard/QuarterNetAddTrend";
import PendingRevenue from "../../components/Modals/Dashboard/PendingRevenue";
import NewBusinessClientList from "../../components/Modals/Dashboard/NewBusinessClientList";
import NewBusinessClientListByIndustry from "../../components/Modals/Dashboard/NewBusinessClientListByIndustry";
import ClientTrend from "../../components/Modals/Dashboard/ClientTrend";
import FloatingFilterPanel from "./components/FloatingFilterPanel";
import { Select, Skeleton, MenuItem } from "@mui/material";
import toastr from "../../utils/toast";

function Dashboard() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [firDashboard, setFirDashboard] = useState(false);
  const [switchOption, setSwitchOption] = useState(false);
  const { setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState(null);
  const [slowdata, setSlowData] = useState([]);
  const [QuarterRevenueModal, setQuarterRevenueModal] = useState(false);
  const [QuarterNetAddModal, setQuarterNetAddModal] = useState(false);
  const [NewBusinessClientModal, setNewBusinessClientModal] = useState(false);
  const [PendingRevenueModal, setPendingRevenueModal] = useState(false);
  const [NewBusinessClientByIndustryModal, setNewBusinessClientByIndustryModal] = useState(false);
  const [ClientTrendModal, setClientTrendModal] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [slowLoading, setSlowLoading] = useState(true);
  const [years, setYears] = useState([]);
  const [CurrentYear, setCurrentYear] = useState(null);

  const removeFilter = (item) => {
    setSelectedFilters(selectedFilters.filter((f) => f !== item));
    setFilters({
      user_id: null,
      sector: null,
      region: null,
      filter_year: filters.filter_year,
    });
  };

  const restrictedUsers = [84, 519];
  const initialFilters = restrictedUsers.includes(user?.id)
    ? { user_id: user?.id, sector: null, region: null, filter_year: null }
    : { user_id: null, sector: null, region: null, filter_year: null };

  const [filters, setFilters] = useState(initialFilters);

  const userRef = useRef(null);

  useEffect(() => {
    if (userRef.current) return;
    userRef.current = true;

    const restrictedUsers = [84, 519];
    const isRestricted = restrictedUsers.includes(user?.id);

    if (isRestricted) {
      // Blocked from firm dashboard
      setFirDashboard(false);
      setSwitchOption(false);
    } else {
      // Allowed to use firm dashboard
      setFirDashboard(true);
      setSwitchOption(true);

      console.log("allowed");
    }
  }, [user]);

  const get_dashboard_data_fast = async (Name) => {
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/dashboard/${Name}`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const d = response.data;
      if (response.status !== 200) {
        toastr.error("Please Try Again");
      }
      console.log("dashboard data", d);
      const current_revenue = d?.revenue_current_year?.[0]?.sum || 0;
      const prev_revenue = d?.revenue_prev_year?.[0]?.sum || 1; // avoid divide by zero
      const current_net_add = d?.net_add_current_year?.[0]?.sum || 0;
      const prev_net_add = d?.net_add_prev_year?.[0]?.sum || 1;
      const revenue_change_log = d?.revenue_change_log || [];
      const revenue_growth = (((current_revenue - prev_revenue) / prev_revenue) * 100).toFixed(2);
      const net_add_growth = (((current_net_add - prev_net_add) / prev_net_add) * 100).toFixed(2);
      const net_add_current_month = d?.net_add_current_month?.[0]?.sum || 0;
      const firm_target = Number(d?.firm_target?.[0]?.amount) || 0;
      const monthly_firm_target = firm_target ? firm_target / 12 : 0;
      const target_achieved = ((current_revenue / firm_target) * 100).toFixed(2);
      const monthly_revenue = d?.monthly_firm_target_achieved?.[0]?.sum || 0;
      const monthly_firm_target_achieved = ((monthly_revenue / monthly_firm_target) * 100).toFixed(2);
      const net_add_current_quarter = d?.net_add_current_quarter?.[0]?.sum || 0;
      const net_add_last_quarter = d?.net_add_last_quarter?.[0]?.sum || 1;
      const net_add_last_month = d?.net_add_last_month?.[0]?.sum || 1;
      const prev_year_net_add_last_quarter = d?.prev_year_net_add_last_quarter?.[0]?.sum || 1;
      const prev_year_net_add_last_month = d?.prev_year_net_add_last_month?.[0]?.sum || 1;
      const net_add_current_week = d?.net_add_current_week?.[0]?.sum || 0;
      const net_add_last_week = d?.net_add_last_week?.[0]?.sum || 1;
      const net_add_quarter_growth = ((net_add_current_quarter - net_add_last_quarter) / net_add_last_quarter) * 100;
      const net_add_month_growth =((net_add_current_month - net_add_last_month) / net_add_last_month) * 100;
      const prev_year_net_add_quarter_growth = ((net_add_current_quarter - prev_year_net_add_last_quarter) / prev_year_net_add_last_quarter) * 100;
      const prev_year_net_add_month_growth = ((net_add_current_month - prev_year_net_add_last_month) / prev_year_net_add_last_month) * 100;
      const net_add_week_growth = ((net_add_current_week - net_add_last_week) / net_add_last_week) * 100;
      const chart_data = d?.revenue_last_five_years;

      console.log(chart_data);

      let values = [];
      chart_data?.forEach((item) => {
        values.push(item.total);
      });

    let userLoging = {};
    userLoging = JSON.parse(localStorage.getItem("user") || "{}");
    const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
    const amountDivisor = defaultCurrencyId === 1 ? 10000000 : 1000;

      const cv = (current_revenue / amountDivisor).toFixed(0);
      const base = values[0] || 1;
      console.log('check percent',cv, base);
      const cagr = ((cv / base) ** (1 / 5) - 1) * 100;
      let total_roles = 0;
      for (const value of Object.values(d?.total_searches?.[0] || {})) {
        total_roles += parseInt(value, 10) || 0;
      }
      const prev_avg_vobt = d?.prev_year_average_vobt?.[0]?.avg_vobt || 0;
      const current_avg_vobt = d?.average_vobt?.[0]?.avg_vobt || 0;
      const avg_growth_vobt = prev_avg_vobt > 0 ? ((current_avg_vobt - prev_avg_vobt) / prev_avg_vobt) * 100 : 0;
      const prev_avg_arpa = d?.prev_year_arpa?.[0]?.avg_arpa || 0;
      const curr_avg_arpa = d?.curr_year_arpa?.[0]?.avg_arpa || 0;
      const avg_growth_arpa = prev_avg_arpa > 0 ? ((curr_avg_arpa - prev_avg_arpa) / prev_avg_arpa) * 100 : 0;

      const partner_performance = {
        business_delivered: d?.business_delivered || [],
        business_generated: d?.business_generated || [],
        self_bd_delivered: d?.self_bd_delivered || [],
        last_year_business_generated: d?.last_year_business_generated || [],
        partner_net_add: d?.partner_net_add || [],
        partner_net_add_current_month: d?.partner_net_add_current_month || [],
      };
      delete d?.business_delivered;
      delete d?.business_generated;
      delete d?.self_bd_delivered;
      delete d?.last_year_business_generated;
      delete d?.revenue_change_log;
      delete d?.monthly_firm_target_achieved;

      const current_quarter = getCurrentQuarter();

      setData({
        ...d,
        revenue_growth,
        net_add_growth,
        monthly_firm_target,
        target_achieved,
        monthly_firm_target_achieved,
        net_add_quarter_growth,
        net_add_month_growth,
        net_add_week_growth,
        cagr,
        total_roles,
        avg_growth_vobt,
        avg_growth_arpa,
        partner_performance,
        prev_year_net_add_quarter_growth,
        prev_year_net_add_month_growth,
        current_quarter,
        revenue_change_log,
        monthly_revenue,
      });
    } catch (error) {
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  function getCurrentQuarter(date = new Date()) {
    const month = date.getMonth() + 1; // 1–12

    if (month >= 4 && month <= 6) return "Q1";
    if (month >= 7 && month <= 9) return "Q2";
    if (month >= 10 && month <= 12) return "Q3";
    return "Q4"; // Jan–Mar
  }

  const get_dashboard_data = async (Name) => {
    try {
      setSlowLoading(true);
      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/dashboard/${Name}`,
        filters,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setSlowData(response.data);
      console.log("slow data", response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setSlowLoading(false);
    }
  };

  useEffect(() => {
    const fy = getLast5FinancialYears();
    setYears(fy);

    // ✅ set default value (IMPORTANT)
    setFilters((prev) => ({
      ...prev,
      filter_year: fy[0].value, // current FY
    }));
    setCurrentYear(fy[0]?.value);
  }, [token]);

  useEffect(() => {
    if (!filters.filter_year) {
      return;
    }

    setData({}); // ✅ clear old data
    setSlowData([]); // ✅ clear old slow data

    let get_dashboard_data_fast_function_name = "get_dashboard_data_fast";
    let get_dashboard_data_function_name = "get_dashboard_data";

    if (filters.filter_year !== CurrentYear) {
      get_dashboard_data_fast_function_name =
        "get_dashboard_data_fast_prev_fy_years";
      get_dashboard_data_function_name = "get_dashboard_data_prev_fy_years";
    }

    get_dashboard_data_fast(get_dashboard_data_fast_function_name);
    get_dashboard_data(get_dashboard_data_function_name);
  }, [filters]);

  function getLast5FinancialYears() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    const currentFYStart = month >= 3 ? year : year - 1;

    return Array.from({ length: 6 }, (_, i) => {
      const start = currentFYStart - i;
      const label = `${start}-${start + 1}`;

      return {
        label,
        value: label,
      };
    });
  }

  return (
    <>
      <style>{`
  .form-switch .form-check-input {
    --bs-form-switch-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e") !important;
    width: 2em;
    margin-left: -2.5em;
    background-image: var(--bs-form-switch-bg);
    background-position: left center;
    border-radius: 2em;
    transition: background-position .15s ease-in-out;
    background-color: #673ab7;
  }

  .form-check-input:checked {
    background-color: #F26522 !important;
    border-color: #F26522;
  }

  .form-switch .form-check-input:focus {
    --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e) !important;
  }
`}</style>
      {selectedFilters.length > 0 && (
        <FloatingFilterPanel
          filters={selectedFilters}
          onRemove={removeFilter}
        />
      )}
      <div className="content">
        {/* <!-- Welcome Wrap --> */}
        <div className="card border-0">
          <div className="card-body d-flex align-items-center justify-content-between flex-wrap pb-1">
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xl flex-shrink-0">
                <img
                  src={`${REACT_APP_BASE_URL}assets/img/profiles/${user.userpic}`}
                  className="rounded-circle"
                  alt="User Profile"
                />
              </span>
              <div className="ms-3">
                <h3 className="mb-2">
                  Welcome Back, {user.firstname + " " + user.lastname}
                  {/* <a href="javascript:void(0);" className="edit-icon">
                    <i className="ti ti-edit fs-14"></i>
                  </a> */}
                </h3>
                {/* <p>
                  You have{" "}
                  <span className="text-primary text-decoration-underline">
                    21
                  </span>{" "}
                  Pending Approvals &{" "}
                  <span className="text-primary text-decoration-underline">
                    14
                  </span>{" "}
                  Leave Requests
                </p> */}
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap mb-1">
              {switchOption && user.designation_id === 2 && (
                <>
                  <label className="form-check-label me-2" htmlFor="switch-lg">
                    My Dashboard
                  </label>

                  <div className="form-check form-check-lg form-switch">
                    <input
                      checked={firDashboard}
                      onChange={(e) => {
                        if (e.target.checked === false) {
                          // Switch to My Dashboard
                          setFilters({
                            user_id: user.id,
                            sector: null,
                            region: null,
                            filter_year: filters.filter_year || null,
                          });
                          setFirDashboard(false);
                        } else {
                          // Switch to Firm Dashboard
                          setFilters({
                            user_id: null,
                            sector: null,
                            region: null,
                            filter_year: filters.filter_year || null,
                          });
                          setFirDashboard(true);
                        }
                      }}
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="switch-lg"
                    />
                    <label className="form-check-label" htmlFor="switch-lg">
                      Firm Dashboard
                    </label>
                  </div>
                </>
              )}

              <Select
                value={filters.filter_year || ""}
                onChange={(e) => {
                  setFilters({
                    filter_year: e.target.value,
                    user_id: filters.user_id || null,
                    sector: filters.sector || null,
                    region: filters.region || null,
                  });
                }}
                size="small"
                style={{ width: 120 }}
              >
                {years.map((y) => (
                  <MenuItem key={y.value} value={y.value}>
                    {y.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        </div>
        {/* <!-- /Welcome Wrap --> */}
        <div className="row">
          {QuarterRevenueModal && (
            <QuarterRevenueTrend
              quarterData={data?.quarter_revenue_trend}
              weeklyData={data?.weekly_revenue_trend}
              monthlyData={data?.monthly_revenue_trend}
              yearlyData={data?.yearly_revenue_trend}
              onClose={() => setQuarterRevenueModal(false)}
            />
          )}
          {QuarterNetAddModal && (
            <QuarterNetAddTrend
              quarterData={slowdata?.quarter_net_add_trend}
              weeklyData={slowdata?.weekly_net_add_trend}
              monthlyData={slowdata?.monthly_net_add_trend}
              yearlyData={slowdata?.yearly_net_add_trend}
              onClose={() => setQuarterNetAddModal(false)}
            />
          )}
          {/* <!-- Widget Info --> */}
          <div className="col-md-12 col-xl-12 col-xxl-12 d-flex">
            <div className="row flex-fill">
              <div
                className="col-md-3 col-xl-3 col-xxl-3 d-flex"
                style={{ cursor: "pointer" }}
              >
                <div className="card flex-fill">
                  <div
                    className="card-body div-focus-border"
                    onClick={() => {
                      setQuarterRevenueModal(true);
                    }}
                  >
                    <h3 className="mb-3 fs-17">Revenue & Net Add</h3>
                    <div className="row mb-3">
                      <div className="col-md-5 col-sm-5">
                        <span className="fw-medium text-defualt mb-3">
                          FY {data?.from?.slice(2, 4)}-{data?.to?.slice(2, 4)}
                        </span>
                      </div>
                      <div className="col-md-7 col-sm-7">
                        <h4 className="mb-0 fw-normal fs-15">
                          {currency_converter_selected(
                            data?.revenue_current_year?.[0]?.sum,
                          )}
                        </h4>
                        <span className="fs-13 fw-light text-default mb-3">
                          Net:{" "}
                          {currency_converter_selected(
                            data?.net_add_current_year?.[0]?.sum,
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-5 col-sm-5">
                        <span className="fw-medium text-defualt mb-3">
                          FY {data?.prev_from?.slice(2, 4)}-
                          {data?.prev_to?.slice(2, 4)}
                        </span>
                      </div>
                      <div className="col-md-7 col-sm-7">
                        <h4 className="mb-0 fw-normal fs-15">
                          {currency_converter_selected(
                            data?.revenue_prev_year?.[0]?.sum,
                          )}
                        </h4>
                        <span className="fs-13 fw-light text-default">
                          Net:{" "}
                          {currency_converter_selected(
                            data?.net_add_prev_year?.[0]?.sum,
                          )}
                        </span>
                      </div>
                    </div>
                    <hr style={{ opacity: "1.25" }} />
                    <div className="row align-items-center mb-1">
                      <div className="col-md-6 col-sm-6">
                        <h5 className="fs-13 fw-normal">Revenue Growth</h5>
                      </div>
                      <div
                        className={`col-md-6 col-sm-6 ${
                          data?.revenue_growth > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        <i
                          className={`fa-solid ${
                            data?.revenue_growth > 0
                              ? "fa-arrow-trend-up"
                              : "fa-arrow-trend-down"
                          }`}
                        ></i>{" "}
                        {data?.revenue_growth}%
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6 col-sm-6">
                        <h5 className="fs-13 fw-normal">Net Add Growth</h5>
                      </div>
                      <div
                        className={`col-md-6 col-sm-6 ${
                          data?.net_add_growth > 0
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        <i
                          className={`fa-solid ${
                            data?.net_add_growth > 0
                              ? "fa-arrow-trend-up"
                              : "fa-arrow-trend-down"
                          }`}
                        ></i>{" "}
                        {data?.net_add_growth}%
                      </div>
                    </div>
                    <hr className="mb-1" style={{ opacity: "1.25" }} />
                    <div className="row">
                      <div className="col-md-12 col-sm-12 align-items-center mb-2">
                        <i className="fa-solid fa-bullseye"></i>
                        <span className="fs-13 fw-medium text-default ms-sm-2">
                          Org Targets
                        </span>
                      </div>
                      <div className="col-md-6 col-sm-6">Yearly Target</div>
                      <div className="col-md-6 col-sm-6">
                        <h6 className="fw-normal mb-0">
                          {currency_converter_selected(
                            data?.firm_target?.[0]?.amount,
                          )}
                        </h6>
                        <span
                          className={`fs-10 ${
                            data?.target_achieved >= 100
                              ? "text-success"
                              : "text-danger"
                          } text-success`}
                        >
                          {data?.target_achieved}% achieved
                        </span>
                      </div>
                      <div className="col-md-6 col-sm-6">Monthly Target</div>
                      <div className="col-md-6 col-sm-6">
                        <h6 className="fw-normal mb-0">
                          {currency_converter_selected(data?.monthly_firm_target)}
                        </h6>
                        <span
                          className={`fs-10 ${
                            data?.monthly_firm_target_achieved >= 100
                              ? "text-success"
                              : "text-danger"
                          } `}
                        >
                          {data?.monthly_firm_target_achieved}% achieved
                        </span>
                      </div>
                      <div className="col-md-6 col-sm-6">Monthly Revenue</div>
                      <div className="col-md-6 col-sm-6 mt-1">
                        <h6 className="fw-normal mb-0">
                          {currency_converter_selected(data?.monthly_revenue)}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-xl-3 col-xxl-3 d-flex"
                onClick={() => {
                  if (slowLoading) {
                    alert("Please Wait");
                    return;
                  }
                  setQuarterNetAddModal(true);
                }}
              >
                <div className="card flex-fill">
                  <div className="card-body div-focus-border">
                    <h3 className="mb-3 fs-17">Net Add</h3>
                    <div className="row d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded-3 p-2 mb-3">
                      <div className="col-md-12 col-sm-12 mb-3">
                        <span className="fw-medium text-defualt">
                          Current Quarter ({data?.current_quarter})
                        </span>
                      </div>
                      <div className="col-md-7 col-sm-7">
                        <h4 className="mb-0 fw-normal fs-15">
                          {currency_converter_selected(
                            data?.net_add_current_quarter?.[0]?.sum,
                          )}
                        </h4>
                      </div>
                      <div className="col-md-5 col-sm-5 d-flex flex-column p-0">
                        <span
                          className={`fs-13 fw-light ${
                            data?.net_add_quarter_growth > 0
                              ? "text-success"
                              : "text-danger"
                          } text-success mb-1`}
                        >
                          <i
                            className={`fa-solid me-sm-1 ${
                              data?.net_add_quarter_growth > 0
                                ? "fa-arrow-trend-up"
                                : "fa-arrow-trend-down"
                            }`}
                          ></i>
                          {data?.net_add_quarter_growth?.toFixed(2)}%
                          <i
                            title="Compared to previous quarter"
                            className="fa-solid fa-circle-info text-info ms-1"
                          ></i>
                        </span>
                        <span
                          className={`fs-13 fw-light ${
                            data?.prev_year_net_add_quarter_growth > 0
                              ? "text-success"
                              : "text-danger"
                          } text-success mb-1`}
                        >
                          <i
                            className={`fa-solid me-sm-1 ${
                              data?.prev_year_net_add_quarter_growth > 0
                                ? "fa-arrow-trend-up"
                                : "fa-arrow-trend-down"
                            }`}
                          ></i>
                          {data?.prev_year_net_add_quarter_growth?.toFixed(2)}%
                          <i
                            title="Compared to previous year`s quarter"
                            className="fa-solid fa-circle-info text-info ms-1"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="row d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded-3 p-2 mb-3">
                      <div className="col-md-12 col-sm-12 mb-3">
                        <span className="fw-medium text-defualt">
                          Current Month
                        </span>
                      </div>
                      <div className="col-md-7 col-sm-7">
                        <h4 className="mb-0 fw-normal fs-15">
                          {currency_converter_selected(
                            data?.net_add_current_month?.[0]?.sum,
                          )}
                        </h4>
                      </div>
                      <div className="col-md-5 col-sm-5 d-flex flex-column p-0">
                        <span
                          className={`fs-13 fw-light ${
                            data?.net_add_month_growth > 0
                              ? "text-success"
                              : "text-danger"
                          } mb-1`}
                        >
                          <i
                            className={`fa-solid me-sm-1 ${
                              data?.net_add_month_growth > 0
                                ? "fa-arrow-trend-up"
                                : "fa-arrow-trend-down"
                            } me-1`}
                          ></i>
                          {data?.net_add_month_growth?.toFixed(2)}%
                          <i
                            title="Compared to previous month"
                            className="fa-solid fa-circle-info text-info ms-1"
                          ></i>
                        </span>
                        <span
                          className={`fs-13 fw-light ${
                            data?.prev_year_net_add_month_growth > 0
                              ? "text-success"
                              : "text-danger"
                          } mb-1`}
                        >
                          <i
                            className={`fa-solid me-sm-1 ${
                              data?.prev_year_net_add_month_growth > 0
                                ? "fa-arrow-trend-up"
                                : "fa-arrow-trend-down"
                            } me-1`}
                          ></i>
                          {data?.prev_year_net_add_month_growth?.toFixed(2)}%
                          <i
                            title="Compared to previous year`s month"
                            className="fa-solid fa-circle-info text-info ms-1"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div className="row d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded-3 p-2 mb-3">
                      <div className="col-md-12 col-sm-12 mb-3">
                        <span className="fw-medium text-defualt">
                          Current Week
                        </span>
                      </div>
                      <div className="col-md-7 col-sm-7">
                        <h4 className="mb-0 fw-normal fs-15">
                          {currency_converter_selected(
                            data?.net_add_current_week?.[0]?.sum,
                          )}
                        </h4>
                      </div>
                      <div className="col-md-5 col-sm-5">
                        <span
                          className={`fs-13 fw-light ${
                            data?.net_add_week_growth > 0
                              ? "text-success"
                              : "text-danger"
                          } mb-3`}
                        >
                          <i
                            className={`fa-solid me-sm-1 ${
                              data?.net_add_week_growth > 0
                                ? "fa-arrow-trend-up"
                                : "fa-arrow-trend-down"
                            } me-1`}
                          ></i>
                          {data?.net_add_week_growth?.toFixed(2)}%
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    {NewBusinessClientModal && (
                      <NewBusinessClientList
                        onclose={() => setNewBusinessClientModal(false)}
                        table_data={data?.new_business_client_list}
                      />
                    )}
                    <h3 className="mb-0 fs-17">New Business Developed</h3>
                    <span className="fs-13 fw-light">
                      Over the last 24 Months
                    </span>
                    <div
                      onClick={() => setNewBusinessClientModal(true)}
                      className="row d-flex align-items-center justify-content-between border border-dotted rounded-3 p-2 mb-3 mt-3 div-focus"
                    >
                      <div className="d-flex align-items-center">
                        <span className="avatar avatar-xxl text-default">
                          <i className="fa-solid fa-briefcase fa-2x border p-1 rounded-2"></i>
                        </span>
                        <div>
                          <p className="mb-0">Total value this FY</p>
                          <h5>
                            {currency_converter_selected(
                              data?.new_business_developed?.[0]?.sum_amount?.toFixed(
                                0,
                              ),
                            )}
                          </h5>
                        </div>
                      </div>
                    </div>
                    {NewBusinessClientByIndustryModal && (
                      <NewBusinessClientListByIndustry
                        onclose={() =>
                          setNewBusinessClientByIndustryModal(false)
                        }
                        table_data={data?.new_business_client_list}
                      />
                    )}

                    <div
                      onClick={() => setNewBusinessClientByIndustryModal(true)}
                      className="row d-flex align-items-center justify-content-between border border-dotted rounded-3 p-2 mb-3 mt-3 div-focus"
                    >
                      <div className="d-flex align-items-center">
                        <span className="avatar avatar-xxl text-default">
                          <i className="fa-solid fa-user-group fa-2x border p-1 rounded-2"></i>
                        </span>
                        <div>
                          <p className="mb-0">New Clients</p>
                          <h5>
                            {data?.new_business_developed?.[0]?.company_count}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <h3 className="mb-0 fs-17">CAGR</h3>
                        <span className="fs-13 fw-light">
                          {data?.from?.slice(0, 4) - 4}-
                          {data?.from?.slice(0, 4)}
                        </span>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <span
                            className={`avatar avatar-md ${
                              data?.cagr > 0 ? "text-success" : "text-danger"
                            }`}
                          >
                            <i
                              className={`fa-solid ${
                                data?.cagr > 0
                                  ? "fa-arrow-trend-up"
                                  : "fa-arrow-trend-down"
                              } fa-2x p-1`}
                            ></i>
                          </span>
                          <div>
                            <h5>{data?.cagr?.toFixed(2)}%</h5>
                            <p className="mb-0 fs-7">5-year growth rate</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <CAGR
                      current_year={
                        filters.filter_year === CurrentYear && data?.from
                      }
                      current_revenue={
                        filters.filter_year === CurrentYear &&
                        data?.revenue_current_year?.[0]?.sum
                      }
                      chart_data={data?.revenue_last_five_years}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <h3
                      className="d-flex fs-17 mb-2"
                      style={{ flexDirection: "row" }}
                    >
                      <span className="avatar rounded-circle bg-purple mb-1 me-2">
                        <i className="fa-solid fa-magnifying-glass"></i>
                      </span>
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <span className="fw-lighter">Total Searches</span>
                        <span>{data?.total_roles}</span>
                      </div>
                    </h3>
                    <div className="row align-items-center">
                      <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                          <span className="d-flex d-block mb-1 text-success">
                            Active&nbsp;Roles:{" "}
                            <h4 className="ms-1">
                              {data?.total_searches?.[0]?.active_roles}
                            </h4>
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                          <span className="d-flex d-block mb-1 text-info">
                            Closed:{" "}
                            <h4 className="ms-1">
                              {data?.total_searches?.[0]?.closed_roles}
                            </h4>
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                          <span className="d-flex d-block mb-1 text-primary">
                            On Hold:{" "}
                            <h4 className="ms-1">
                              {data?.total_searches?.[0]?.on_hold_roles}
                            </h4>
                          </span>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                          <span className="d-flex d-block mb-1 text-secondary">
                            Shelved:{" "}
                            <h4 className="ms-1">
                              {data?.total_searches?.[0]?.on_shelved}
                            </h4>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ClientTrendModal && (
                <ClientTrend
                  onClose={() => setClientTrendModal(false)}
                  chartData={data?.client_trend}
                />
              )}
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div
                  onClick={() => setClientTrendModal(true)}
                  className="card flex-fill div-focus-border"
                >
                  <div className="card-body">
                    <h3
                      className="d-flex fs-17 mb-3"
                      style={{ flexDirection: "row" }}
                    >
                      <span className="avatar rounded-circle bg-pink mb-1 me-2">
                        <i className="fa-solid fa-universal-access"></i>
                      </span>
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <span className="fw-lighter">Active Clients Count</span>
                        <span>
                          {data?.total_active_clients?.[0]?.active_clients}
                        </span>
                      </div>
                    </h3>
                    <div className="row align-items-center">
                      <i className="fw-10">Click to view client growth</i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <h3
                      className="d-flex fs-17 mb-3"
                      style={{ flexDirection: "row" }}
                    >
                      <span className="avatar rounded-circle bg-warning mb-1 me-2">
                        <i className="fa-solid fa-file-invoice"></i>
                      </span>
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <span className="fw-lighter">Avg VOBT</span>
                        <span>
                          {currency_converter_selected(
                            data?.average_vobt?.[0]?.avg_vobt,
                          )}
                        </span>
                      </div>
                    </h3>
                    <div
                      className={`d-flex align-items-center ${
                        data?.avg_growth_vobt > 0
                          ? "text-success"
                          : "text-danger"
                      } mb-2`}
                    >
                      <i
                        className={`fa-solid ${
                          data?.avg_growth_vobt > 0
                            ? "fa-arrow-trend-up"
                            : "fa-arrow-trend-down"
                        } me-1`}
                      ></i>
                      <span className="fw-10">
                        {data?.avg_growth_vobt?.toFixed(2)}% vs last year till
                        date
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-10">Total Comp / Closures</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xl-3 col-xxl-3 d-flex">
                <div className="card flex-fill">
                  <div className="card-body">
                    <h3
                      className="d-flex fs-17 mb-3"
                      style={{ flexDirection: "row" }}
                    >
                      <span className="avatar rounded-circle bg-secondary mb-1 me-2">
                        <i className="fa-solid fa-chart-simple"></i>
                      </span>
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <span className="fw-lighter">ARPA</span>
                        <span>
                          {currency_converter_selected(
                            data?.curr_year_arpa?.[0]?.avg_arpa,
                          )}
                        </span>
                      </div>
                    </h3>
                    <div
                      className={`d-flex align-items-center ${
                        data?.avg_growth_arpa > 0
                          ? "text-success"
                          : "text-danger"
                      } mb-2`}
                    >
                      <i
                        className={`fa-solid ${
                          data?.avg_growth_arpa > 0
                            ? "fa-arrow-trend-up"
                            : "fa-arrow-trend-down"
                        } me-1`}
                      ></i>
                      <span className="fw-10">
                        {data?.avg_growth_arpa?.toFixed(2)}% vs last year till
                        date
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-10">Total Fees / Closures</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- /Widget Info --> */}
          {filters.filter_year === CurrentYear && (
            <div className="col-xxl-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                  <h5 className="mb-2">Revenue Change Log</h5>
                </div>
                <div className="card-body">
                  <RevenueChangeLog
                    table_data={data?.revenue_change_log}
                    partner_id={(value) => {
                      if (
                        (switchOption && user.designation_id <= 2) ||
                        user.admin === '1'
                      ) {
                        setFilters({
                          user_id: value,
                          filter_year: filters.filter_year || null,
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {PendingRevenueModal && (
            <PendingRevenue
              pendingData={data?.pending_2nd_retainer}
              onClose={() => setPendingRevenueModal(false)}
            />
          )}
          {/* <!-- Employees By Department --> */}
          <div className="col-xxl-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Revenue Collection Funnel</h5>
                <span class="badge bg-danger" style={{ cursor: "pointer" }} onClick={() => {
                  setPendingRevenueModal(true)
                  }}>2nd Retainer Not In PINE</span>
              </div>
              <div className="card-body">
                <RevenueCollectionFunnel
                  chart_data={data?.revenue_collection_funnel}
                />
              </div>
            </div>
          </div>
          {/* <!-- /Employees By Department --> */}
        </div>

        <div className="row">
          {/* <!-- Attendance Overview --> */}
          <div className="col-xxl-6 col-xl-6">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                  Geographic Distribution
                  <span className="fs-12 fw-light mt-1">
                    Click on region to filter dashboard
                  </span>
                </h5>
              </div>
              <div className="card-body">
                <GeographicDistribution
                  chart_data={data?.region_revenue}
                  setRegionId={(value) => {
                    if (
                      (switchOption && user.designation_id <= 2) ||
                      user.admin === '1'
                    ) {
                      setFilters({
                        region: value,
                        filter_year: filters.filter_year || null,
                      });
                    }
                  }}
                  setRegionName={(value) => {
                    if (
                      (switchOption && user.designation_id <= 2) ||
                      user.admin === '1'
                    ) {
                      setSelectedFilters([value]);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {/* <!-- /Attendance Overview --> */}

          {/* <!-- Clock-In/Out --> */}
          <div className="col-xxl-6 col-xl-6">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                  Sector Distribution
                  <span className="fs-12 fw-light mt-1">
                    Click on sector to filter dashboard
                  </span>
                </h5>
              </div>
              <div className="card-body">
                <SectorDistribution
                  chart_data={data?.sector_revenue}
                  setSectorId={(value) => {
                    if (
                      (switchOption && user.designation_id <= 2) ||
                      user.admin === '1'
                    ) {
                      setFilters({
                        sector: value,
                        filter_year: filters.filter_year || null,
                      });
                    }
                  }}
                  setSectorName={(value) => {
                    if (
                      (switchOption && user.designation_id <= 2) ||
                      user.admin === '1'
                    ) {
                      setSelectedFilters([value]);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {/* <!-- /Clock-In/Out --> */}
        </div>

        <div className="row">
          {/* <!-- Jobs Applicants --> */}
          <div className="col-xxl-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                  Partner Performance
                  <span className="fs-12 fw-light mt-1">
                    Click on partner name to filter dashboard
                  </span>
                </h5>
              </div>
              <div className="card-body">
                <PartnerPerformance
                  table_data={data?.partner_performance}
                  partner_id={(value) => {
                    if ((switchOption && user.designation_id <= 2) || user.admin === '1' ) {
                      setFilters({
                        user_id: value,
                        filter_year: filters.filter_year || null,
                      });
                    }
                  }}
                  partner_name={(value) => {
                    if (
                      (switchOption && user.designation_id <= 2) ||
                      user.admin === '1'
                    ) {
                      setSelectedFilters([value]);
                    }
                  }}
                />
              </div>
            </div>
          </div>
          {/* <!-- /Jobs Applicants --> */}

          {/* <!-- Employees --> */}
          <div className="col-xxl-12 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2">Sector Performance</h5>
              </div>
              <div className="card-body p-1">
                {slowLoading ? (
                  <Skeleton height={300} />
                ) : (
                  <SectorPerformance
                    table_data={slowdata?.sector_performance}
                  />
                )}
              </div>
            </div>
          </div>
          {/* <!-- /Employees --> */}
        </div>
        {(slowdata?.client_at_risk_by_company?.length > 0 ||
          slowdata?.roleatrisk?.length > 0) && (
          <div className="row">
            {slowdata?.client_at_risk_by_company?.length > 0 && (
              <div className="col-xxl-6 col-xl-6 d-flex">
                <div className="card flex-fill">
                  <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                    <h5
                      className="mb-2 d-flex"
                      style={{ flexDirection: "column" }}
                    >
                      Clients At Risk
                    </h5>
                  </div>
                  <div className="card-body">
                    {slowLoading ? (
                      <Skeleton height={300} />
                    ) : (
                      <TopClientRisk
                        table_data={slowdata?.client_at_risk_by_company}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {slowdata?.roleatrisk?.length > 0 && (
              <div className="col-xxl-6 col-xl-6">
                <div className="card flex-fill">
                  <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                    <h5
                      className="mb-2 d-flex"
                      style={{ flexDirection: "column" }}
                    >
                      Roles At Risk
                    </h5>
                  </div>
                  <div className="card-body">
                    {slowLoading ? (
                      <Skeleton height={300} />
                    ) : (
                      <TopRolesRisk table_data={slowdata?.roleatrisk} />
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="row">
          <div className="col-xxl-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                  Top Revenue Generating Clients
                </h5>
              </div>
              <div className="card-body">
                <TopRevenueClients table_data={data?.client_revenue} />
              </div>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6">
            <div className="card flex-fill">
              <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                  Top Clients Details
                </h5>
              </div>
              <div className="card-body">
                <TopClientsDetails table_data={data?.client_revenue} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
